/*import React from 'react'
import Helmet from 'react-helmet'

const termsConditionsEn = () => (
  <div className="page terms_conditions">
    <Helmet
      title={`Budget Nicaragua Terms & Conditions - Find a Car Rental Near You`}
      meta={[
        {
          name: 'description',
          content: 'Frequently Asked Questions about car rentals.',
        },
      ]}
      link={[
        {
          rel: 'alternate',
          hreflang: 'en',
          href: './es/terms_conditions',
        },
      ]}
    />

    {/* <div className="image"></div> }
    <h1>Terms & Conditions</h1>
    <br />

    <div className="wrapper">
      <div>
        <h2>General terms of car rental</h2>
        <p>
          <li> Reservations are at least 24 hours in advance.</li>
          <li>
            The daily rate applies for a maximum of 24 hours of rental of the
            vehicle.
          </li>
          <li> The minimum age for clients and drivers is 25 years.</li>
          <li> The credit card must be in the name of the customer.</li>
          <li> SLI coverage is mandatory in Budget Nicaragua.</li>
        </p>
        <div
          style={{
            background: '#F78621',
            height: '3px',
            margin: '0px 0px 20px 0px',
          }}
        />

        <h2>To rent the vehicle we require</h2>
        <p>
          <li>
            Identification document (identity card or passport in the case of
            foreigners)
          </li>
          <li>Valid drivers license</li>
          <li>Present a credit or debit card at the time of rental.</li>
        </p>
        <div
          style={{
            background: '#F78621',
            height: '3px',
            margin: '0px 0px 20px 0px',
          }}
        />

        <h2>Damage deposit and cancellation:</h2>
        <p>
          <li>
            For the rent of the vehicle, a credit card deposit is required,
            which ranges from US $ 500.00 to US $ 1,500.00 or more depending on
            the category of the vehicle and the duration of the rental.
          </li>
          <li>
            Credit card deposits require a minimum amount of $ 600.00 - U $
            1,500.00 or more depending on the category of the vehicle and the
            duration of the rent, and the client must pre-pay the rent.
          </li>
          <li>
            For cancellation of the rental agreement you can use a credit card,
            debit card or cash. Budget Nicaragua does not allow the initial
            deposit with Discover cards, only to cancel the rental agreement.
          </li>
        </p>
        <div
          style={{
            background: '#F78621',
            height: '3px',
            margin: '0px 0px 20px 0px',
          }}
        />

        <h2>Gas</h2>
        <p>
          <li>
            The vehicle is delivered full of fuel and must return in the same
            conditions, this data is specified in therental agreement.
          </li>
        </p>
        <div
          style={{
            background: '#F78621',
            height: '3px',
            margin: '0px 0px 20px 0px',
          }}
        />

        <h2>Additional Driver Policies and Procedures</h2>
        <p>
          <li>
            Additional driver must be over 25 years of age and less than or
            equal to 70 years.
          </li>
          <li>Valid drivers license.</li>
          <li>
            Have the correct category on license for the type of vehicle model
            you will be driving. No automobile and / or traffic violations
            (fines).
          </li>
          <li>
            All required documents will be scanned and / or photocopied by
            Budget Rent a Car. Drivers must be present when opening the rental
            agreement. They must submit their necessary documents to be added
            (meet all additional driver requirements).
          </li>
          <li>
            The additional driver's note must be completed and signed, which
            will be delivered to the counter at the time the rental agreement is
            opened. And it must be signed and authorized by the customer
            responsible for the rental agreement.
          </li>
          <li>
            If the additional driver is not present at the moment of opening the
            rental agreement and wishes to add the driver later, the client, the
            additional driver and the rental vehicle must be presented at the
            nearest branch office and sign the required documentation (Comply
            with all requirements of Additional drivers).
          </li>
          <li>
            The additional driver does not have any cost in case of: Spouse of
            the renter, when the holder cannot drive or does not have a license
            to do so.
          </li>
          <li>
            The additional driver (s) has a cost of US $ 5.00 per day (US $ 10
            per day in case of income outside the country), when it does not
            comply with the following: Holder cannot drive or have no license to
            do so.
          </li>
          <li>The maximum number of additional driver is 4.</li>
          <li>
            The maximum amount to be paid by each additional driver will be US $
            100.00 per month per rental agreement.
          </li>
          <li>We reserve the right to accept or not the additional driver.</li>
          <li>
            The additional driver cannot modify the original rental agreement,
            in any of its terms.
          </li>
        </p>
        <div
          style={{
            background: '#F78621',
            height: '3px',
            margin: '0px 0px 20px 0px',
          }}
        />
      </div>
    </div>

    <h1>Terms and Conditions for Online Pre-Paid Rentals</h1>
    <br />
    <div className="wrapper">
      <div>
        <p>
          <li> The rental agreement will be in the name of the person making the reservation and the pre-payment and the person must comply with the established rental agreement requirements.</li>
          <li> The minimum age for clients and drivers is 25 years.</li>
          <li> Have a valid driver's license.</li>
          <li> Present identification document (identity card or passport)</li>
          <li> The credit or debit card must be in the name of the customer who made the pre-payment online.</li>
          <li>The customer who performs the pre-payment online must present the counter with the same credit or debit card used to make the pre-payment.</li>
          <li>At the time of the rental, the customer must present the same card used in the pre-payment and additional must leave a deposit for the rental of the vehicle (the deposit must be with the same card and have a minimum availability of US $ S 500.00 - US $ 800.00 or more depending on the amount and time of the rent).</li>
          <li>In case of using credit and debit cards, the mandatory coverage to be taken is US $ 12.99 per day, the other coverages to protect the vehicle are optional.</li>
          <li>The rental agreement is for 30 days, in case your prepaid reservation is for longer than stipulated, you must renew the monthly contract by visiting one of our offices along with the presence of the rented vehicle.</li>
        </p>
        <div
          style={{
            background: '#F78621',
            height: '3px',
            margin: '0px 0px 20px 0px',
          }}
        />

        <h2>No changes are made to the online reservation.</h2>
        <p>
          <li>For any type of change once the reservation has been made, you must contact the Reservations Department at reservas@budget.com.ni, reserve@budget.com.ni or call (505) 2255-9000, from the USA (786) 955- 9000, changes may incur additional charges.</li> 
        </p>

        <div
          style={{
            background: '#F78621',
            height: '3px',
            margin: '0px 0px 20px 0px',
          }}
        />


        <h2>Penalty for cancellation in online booking.</h2>
        <p>
          <li>Cancellations received 72 hours or more prior to the date of your reservation, no penalty will be charged.</li> 
          <li>Cancellations received between 24 - 72 hours before the date of your reservation, the penalty will be $ 25.00 (twenty five US dollars) or the total of the rent (in case the pre-payment is less than the penalty charge) and will be charged from the same credit or debit card with which you made the pre-payment.</li>
          <li>Cancellations received less than 24 hours before the date of your reservation, the penalty will be 50.00 (fifty US dollars) or the total of the rent (in case the pre-payment is less than the penalty charge) and will be charged from the same credit or debit card with which you made the pre-payment.</li>
          <li>Once the reservation has been made with pre-payment included, if the vehicle is returned before the date agreed in the rental agreement, no refund will be made.</li>
        </p>

        <div
          style={{
            background: '#F78621',
            height: '3px',
            margin: '0px 0px 20px 0px',
          }}
        />

        <h2>Penalty for No show.</h2>
        <p>
          <li>If you do not show up at the time of booking, your vehicle will be reserved for an additional 2 hours. Upon passing the period your entire reservation will be charged and the vehicle will be released and can be rented by another customer.</li> 
           </p>

        <div
          style={{
            background: '#F78621',
            height: '3px',
            margin: '0px 0px 20px 0px',
          }}
        />

         <h2>Request for Refunds If applicable.</h2>
        <p>
          <li>Requests for reimbursement of canceled reservations must be requested from reservaciones@budget.com.ni, reserve@budget.com.ni or by calling (505) 2255-9000, from the USA (786) 955-9000, on busuiness hours from 8:00 a.m. At 5:30 p.m. Monday to Friday, Nicaragua time zone.</li> 
          <li>The request for refund must be made by the client for a maximum of 15 days after the date of cancellation of the online reservation otherwise the refund will not be made</li> 
          <li>Refunds cannot be paid at the counter, or cash, these will be credited to the same credit or debit card used to make the pre-payment, within 15 business days after receiving your request.</li> 
           </p>

        <div
          style={{
            background: '#F78621',
            height: '3px',
            margin: '0px 0px 20px 0px',
          }}
        />

   
      </div>
    </div>


  </div>
)
export default termsConditionsEn*/



import React, { Component } from 'react'
import Img from 'gatsby-image'
import carImage from '../images/leasing/car.jpg'
import axios from 'axios'
import Helmet from 'react-helmet'
import { backendURL } from '../data/config.json'
import Link from 'gatsby-link'


class termsConditionsEn extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      descriptionTerminosEn: '',

      titleTerminos:{
        en: '',
        es: ''
      },

    }

    this.renderTextsTerminos = this.renderTextsTerminos.bind(this)

    
  }
  componentDidMount() {
  
      axios
      .get(`${backendURL}/api/texts/sections/TextTerminos/Main`)  
      .then(res => {

        const txt = res.data;

        console.log(txt);

        this.setState({     
          descriptionTerminosEn:{
            en: txt.descriptionTerminosEn,
          }, 

          titleTerminos:{
            en: txt.titleTerminos.en,
            es: txt.titleTerminos.es
          },


        })
        })

    
      .catch(err => {
        console.log(err)
      })
  }


  renderTextsTerminos() {
    const { texts } = this.state
    return _.map(texts, (text, i) => {
      const { descriptionTerminosEn , published } = text
      //const { langKey: lang } = this.props.pathContext
      console.log(text);
      if (published) {
        return (
          <div key={i}>

          <p> 
            {titleTerminos.en} 
          </p>

          <p> 
            {descriptionTerminosEn.en} 
          </p>
          </div>
        )
        return null
      }
    })
  } 


  render() {
    return (
      <div className="page corporate_program">
      <Helmet
         title={`Corporate Program |  Budget Guatemala`}
         meta={[
           {
             name: 'description',
             content:
               'Frequently Asked Questions about car rentals.',
           },
         ]}
         link={[
           {
             rel: 'alternate',
             hreflang: 'en',
             href:
               './es/corporate_program',
           },
         ]}
       />
      
   <h1> {this.state.titleTerminos.en}</h1>

   <div style={{background: '#F78621' , height: '55px', margin:'-15px 0 15px 0', color:'#fff' ,padding:' 1% 0% 1% 0%', textAlign: 'center'}}>
          <p>
          THANK YOU FOR RENTING WITH BUDGET
          </p>
    </div>

    <div dangerouslySetInnerHTML={{__html: this.state.descriptionTerminosEn.en}}></div>
</div>
    )
  }
}
export default termsConditionsEn




// WEBPACK FOOTER //
// ./src/pages/terms_conditions.en.js